/** @module others/filter */
import store from "../store";
import $ from "jquery";
/**
 * The attachments filter selectors.
 */

export var FILTER_SELECTOR = ".attachment-filters.attachment-filters-rml";
/**
 * The filter select dropdown prepared as backbone object.
 */

export var filter = {
  id: "media-attachment-filters-rml",
  className: "attachment-filters attachment-filters-rml",
  lastSlugs: {},
  createFilters: function createFilters(namesSlug) {
    var _this = this;

    this.$el.data("backboneView", this); // default "all" filter, shows all tags

    var filters = this.filters = {
      all: {
        text: "All",
        props: {
          rml_folder: "",
          orderby: "date",
          order: "DESC"
        },
        priority: 10
      }
    }; // No filters loaded, yet

    if (namesSlug) {
      this.lastSlugs = namesSlug;
      var names = namesSlug.names,
          slugs = namesSlug.slugs; // create a filter for each tag

      var props, node;

      for (var i = 0; i < names.length; i++) {
        node = store.getTreeItemById(slugs[i]);
        props = {
          rml_folder: slugs[i],
          orderby: "date",
          order: "DESC"
        }; // Add order by

        if (node && (node.contentCustomOrder === 1 || node.forceCustomOrder)) {
          props.orderby = "rml";
          props.order = "ASC";
        }

        filters[slugs[i]] = {
          text: names[i],
          props: props,
          priority: 20 + i
        };
      }
    } //this.model.set(filters['all'].props); // Implemented in mediaViews


    if (namesSlug) {
      // Build `<option>` elements.
      this.$el.html(Object.keys(this.filters).map(function (key) {
        return $("<option></option>").val(key).html(_this.filters[key].text)[0].outerHTML;
      }).join("")); // Reselect

      this.select();
    }
  }
};